import React, { Component } from 'react';
import './FavouriteEntry.css';
import ParameterErrors from '../errors/ParameterErrors';
import IconButton from './IconButton';
import Checkbox from './Checkbox';
import { faBackward, faTimes} from '@fortawesome/free-solid-svg-icons'
import Urls from '../urls/Urls';
const  {throwNotProvided, throwNotOfType} = ParameterErrors;
export default class FavouriteEntry extends Component {
	constructor(props){
		super(props);
		const {favourite, onClickRemove, configuration}=props;
		this._configuration = configuration;
		if(!favourite)throwNotProvided('favourite');
		this._inputCheckbox = React.createRef();
		this._callbackClickRemove = onClickRemove;
		this._handleCheckboxChanged = this._handleCheckboxChanged.bind(this);
		this._handleClickClose = this._handleClickClose.bind(this);
		this._handleClick = this._handleClick.bind(this);
		this._favourite = favourite;
		this._selected = true;
		this.state ={};
	}
	componentDidMount(){
		this._inputCheckbox.current.checked=this._selected;
	}
	get sortValue(){
		return this._favourite.sortValue;
	}
	get hash(){
		return this._favourite.hash;
	}
	get favourite(){
		return this._favourite;
	}
	get selected(){
		return this._selected;
	}
	_handleCheckboxChanged(e){
		this._selected = e.checked;
	}
	_handleClickClose(e){
		this._callbackClickRemove(this._favourite);
		e.stopPropagation&&e.stopPropagation();
	}
	_handleClick(e){
		this._favourite.onClick();
	}
	render() {
		let className ="favourite-entry";
		if(this.state.visible)
			className+=" visible";
		return (<div className={className} onClick={this._handleClick}>
					<div className="image-wrapper">
						<img className="image" src = {this._favourite.imageUrl}></img>
					</div>
					<div className="description-wrapper">
						<div className="description" dangerouslySetInnerHTML={{ __html: this._favourite.description }}></div>
					</div>
					<Checkbox ref={this._inputCheckbox} toggleOnClick={true} onChange={this._handleCheckboxChanged}
						stopEventsPropagating={true}/>
					<div className="button-remove-wrapper" >
						<IconButton imgUrl ={Urls.getAssetsForSite(this._configuration.siteSlug)+'icons/UI_Button_Exit.png'} className="close" onClick={this._handleClickClose}></IconButton>
					</div>
				</div>);
	}
}
